import { useState, type ReactNode } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';

export function CollapsiblePanel({
  title,
  summary,
  open,
  onOpenChange,
  children,
  id,
  className = '',
}: {
  title: string;
  summary?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: ReactNode;
  id?: string;
  className?: string;
}) {
  const reduceMotion = useReducedMotion();
  return (
    <div id={id} className={`scroll-mt-24 ${className}`.trim()}>
      <button
        type="button"
        onClick={() => onOpenChange(!open)}
        className="btn-press flex w-full items-center justify-between gap-3 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 text-left transition-colors hover:bg-white/[0.05]"
      >
        <div className="min-w-0">
          <div className="font-display text-sm font-semibold text-white">{title}</div>
          {summary && !open ? <div className="mt-0.5 truncate text-xs text-zinc-500">{summary}</div> : null}
        </div>
        <span className="shrink-0 text-lg text-zinc-500">{open ? '−' : '+'}</span>
      </button>
      <AnimatePresence initial={false}>
        {open ? (
          <motion.div
            initial={reduceMotion ? false : { height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={reduceMotion ? undefined : { height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <div className="pt-3">{children}</div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
